import { useEffect, useState } from 'react';
import { Play, Square } from 'lucide-react';
import { getEngine, useEngineRunning, playerBpm, preparedPlayer, startWithCountIn } from '@/lib/engines';
import { clickBus } from '@/lib/clickBus';

const COUNT_IN = 2;

// Starts the drone with a metronome (Player or page Click) that also plays the 2-bar count-in.
export const PlayRow = ({ drone }) => {
  const click = getEngine('click');
  const player = getEngine('player');
  const clickOn = useEngineRunning(click);
  const playerOn = useEngineRunning(player);
  const [clickBpm, setClickBpm] = useState(() => Math.round(click.bpm));
  useEffect(() => click.onBpm((b) => setClickBpm(Math.round(b))), [click]);
  const source = drone.prog.bpmSource || 'player';
  const running = source === 'player' ? playerOn : clickOn;
  const bpms = { player: playerBpm(), click: clickBpm };
  const counting = running && drone.barCount === 0;

  const toggle = () => {
    if (running) {
      (source === 'player' ? player : click).stop();
      if (drone.active) drone.toggle();
      return;
    }
    // Metronome first: its start resets the chord sequence before the drone sounds.
    if (source === 'player') startWithCountIn(preparedPlayer(), COUNT_IN);
    else clickBus.control?.startWith({ countIn: COUNT_IN });
    if (!drone.active) drone.toggle();
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <button
        data-testid="drone-prog-play"
        onClick={toggle}
        className={`h-11 px-5 rounded-full flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] active:scale-95 transition-[transform,background-color] ${running ? 'bg-sky-400 text-black' : 'bg-pink-400 text-black'}`}
      >
        {running ? <Square className="w-4 h-4" /> : <Play className="w-4 h-4" />}
        {running ? 'Stop' : 'Play a tempo'}
      </button>
      <div className="flex rounded-full border border-white/10 p-0.5" role="radiogroup" aria-label="Velocità">
        {[{ v: 'player', label: 'Metronomo Player' }, { v: 'click', label: 'Click Bordone' }].map((o) => (
          <button
            key={o.v}
            data-testid={`drone-prog-bpm-${o.v}`}
            role="radio"
            aria-checked={source === o.v}
            onClick={() => drone.updateProg({ bpmSource: o.v })}
            className={`h-9 px-3 rounded-full text-[10px] uppercase tracking-[0.15em] transition-colors ${source === o.v ? 'bg-white/10 text-white' : 'text-white/50 hover:text-white/80'}`}
          >
            {o.label} <span data-testid={`drone-prog-bpm-${o.v}-value`} className="font-mono text-sky-300">{bpms[o.v]}</span>
          </button>
        ))}
      </div>
      {counting && <span data-testid="drone-prog-countin" className="text-[10px] uppercase tracking-[0.2em] text-amber-300 animate-pulse">Conto alla rovescia · {COUNT_IN} battute</span>}
    </div>
  );
};
